import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { preloadImage } from "@/utils/preload-image";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetPlan = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.PLAN],
    staleTime: QueryStaleTime.LONG,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await PlansService.getPlanApiV1PlansGet(user.id);
      // preload images
      console.log("=== result from get plan ===", data);
      const daily = data?.nutrition?.daily;
      console.log("=== daily from get plan ===", daily);
      const dailyTarget = Object.entries(daily ?? {}).map(([index, value]) => {
        return {
          index,
          calories: value.calories,
          calories_diviation: value.calories_deviation,
          calories_target: value.calories_target,
        };
      });
      console.table(dailyTarget);
      data.plan.forEach((plan) => {
        plan.data.forEach((day) => {
          day.meals.forEach((meal) => {
            meal.data.forEach((mealTime) => {
              preloadImage(mealTime.imageUri);
            });
          });
        });
      });
      return data;
    },
  });

  return { plan: data, isLoading, isError, error, refetch };
};
